import React from "react";
import Text from "@amzn/meridian/text";
import Column from "@amzn/meridian/column";

const SubContent = ({ title, content }) => {
  return (
    <Column spacing="none">
      <Text fontFamily={"amazonEmber"} type={"h100"}>
        {title}
      </Text>
      <Text fontFamily={"bookerly"} type={"b300"}>
        {content}
      </Text>
    </Column>
  );
};

export default SubContent;
